module.exports = __webpack_public_path__ + "static/img_9820-6783ebb7cb6e9b74a2aa9f75aac6f545.webp";